// 获取Cookie
export const getCookie = function (name) {
    let strCookie = document.cookie;
    let arrCookie = strCookie.split(';');
    for (let i = 0; i < arrCookie.length; i++) {
        let arr = arrCookie[i].split('=');
        if (arr[0].replace(/(^\s*)|(\s*$)/g, '') === name) {
            return arr[1];
        }
    }
    return '';
};

export const setCookie = function (cname, cvalue, exdays) {
    if (cvalue === null) {
        delCookie(cname);
    }
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toGMTString();
    let path = "path='/'";
    document.cookie = cname + '=' + cvalue + '; ' + expires + path;
};

export const delCookie = function removeCookie(key){
	setCookie(key, '',  -1)
}